import FontFaceObserver from 'fontfaceobserver';

export default () => {
	const $html = document.getElementsByTagName('html')[0];
	const denton = new FontFaceObserver('Denton-Light');
	const helvetica = new FontFaceObserver('helvetica-neue-lt-pro');

	Promise.all([denton.load(), helvetica.load()])
		.then(() => $html.classList.add('fonts-loaded'))
		.catch(() => $html.classList.add('fonts-failed'));
};
